'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.NO = exports.FOP = exports.PO = exports.FO = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:58:45Z                      #

// ##############################################################

/**
 * Typ subjektu.
 */

/**
 * Fyzická osoba.
 */
var FO = exports.FO = 'FO';

/**
 * Právnická osoba.
 */
var PO = exports.PO = 'PO';

/**
 * Podnikající fyzická osoba.
 */
var FOP = exports.FOP = 'FOP';

/**
 * Neznámá osoba.
 */
var NO = exports.NO = 'NO';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [FO, PO, FOP, NO];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, FO, { caption: 'Fyzická osoba.' }), (0, _defineProperty3.default)(_params, PO, { caption: 'Právnická osoba.' }), (0, _defineProperty3.default)(_params, FOP, { caption: 'Podnikající fyzická osoba.' }), (0, _defineProperty3.default)(_params, NO, { caption: 'Neznámá osoba.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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